module.exports = __webpack_public_path__ + "img/seven1Blue.0f5951b9.jpg";